import { IUser } from "../../account/user/interfaces";
import { IEntityManagerProps, IEntityManagerStates, IInitialData } from "../../components/entityManager/interfaces";
import { IFilter } from "../../components/infrastructure/filtering";
import { IEntity, IFetchingInfo } from "../../components/infrastructure/models";
import { IAttachment } from "../attachment/interfaces";
import { ICenter } from "../center/interfaces";
import { ICity } from "../city/interfaces";
import { ICustomerEquipmentModel } from "../customerEquipmentModel/interfaces";
import { IEquipmentProblem } from "../equipment/interfaces";
import { IProvince } from "../province/interfaces";

export enum enmRepairCaseStatus {
    AssignCenter = 1,
    Repairation = 2,
    Rejected = 3,
    Completed = 4,
    Payment = 5,
    ReturnDevice = 6,
    Archived = 7
}

export enum enmRepairationStatus {
    RequestCheck = 1,
    SendDevice = 2,
    Estimation = 3,
    CustomerConfirmation = 4,
    RepairationComplete = 5,
    CustomerRejected = 6,
    Failed = 97,
    Completed = 98,
    Rejected = 99
}

export enum enmSendMethods {
    PolicyholderInPerson = 1,
    Courier = 2
}

export enum enmRepairCaseCheckStates {
    Rejected = 1,
    Confirmed = 2
}

export enum enmPolicyholderRepairResponseTypes {
    Cancel = 1,
    Agree = 2,
}

export const repairCaseStatusOptions = [
    { title: 'منتظر بررسی و ارسال به کارشناس', value: enmRepairCaseStatus.AssignCenter },
    { title: 'در دست اقدام', value: enmRepairCaseStatus.Repairation },
    { title: 'رد شده', value: enmRepairCaseStatus.Rejected },
    { title: 'خاتمه یافته', value: enmRepairCaseStatus.Completed },
    { title: 'منتظر پرداخت', value: enmRepairCaseStatus.Payment },
    { title: 'منتظر تحویل به مشتری', value: enmRepairCaseStatus.ReturnDevice },
    { title: 'بایگانی شده', value: enmRepairCaseStatus.Archived }
];

export const repairationStatusOptions = [
    { userCartableTitle: 'منتظر بررسی کارشناس', centerCartableTitle: 'منتظر بررسی کارشناس', name: 'بررسی درخواست', value: enmRepairationStatus.RequestCheck },
    { userCartableTitle: 'منتظر ارسال دستگاه', centerCartableTitle: 'منتظر دریافت دستگاه', name: 'دریافت دستگاه', value: enmRepairationStatus.SendDevice },
    { userCartableTitle: 'منتظر برآورد هزینه', centerCartableTitle: 'منتظر برآورد هزینه', name: 'برآورد هزینه', value: enmRepairationStatus.Estimation },
    { userCartableTitle: 'منتظر ثبت نظر مشتری', centerCartableTitle: 'منتظر ثبت نظر مشتری', name: 'تاییدیه مشتری', value: enmRepairationStatus.CustomerConfirmation },
    { userCartableTitle: 'درحال  انجام تعمیرات', centerCartableTitle: 'درحال  انجام تعمیرات', name: 'تعمیرات', value: enmRepairationStatus.RepairationComplete },
    { userCartableTitle: 'رد شده توسط مشتری', centerCartableTitle: 'رد شده توسط مشتری', name: 'رد شده توسط مشتری', value: enmRepairationStatus.CustomerRejected },
    { userCartableTitle: 'غیرقابل تعمیر', centerCartableTitle: 'غیرقابل تعمیر', name: 'غیرقابل تعمیر', value: enmRepairationStatus.Failed },
    { userCartableTitle: 'پایان تعمیرات', centerCartableTitle: 'پایان تعمیرات', name: 'پایان تعمیرات', value: enmRepairationStatus.Completed },
    { userCartableTitle: 'رد شده', centerCartableTitle: 'رد شده', name: 'رد شده', value: enmRepairationStatus.Rejected },
];


export const sendMethodsOptions = [
    { disabled: false, name: "ارسال حضوری", userCartableTitle: "منتظر ارسال دستگاه", centerCartableTitle: "منتظر دریافت دستگاه", value: enmSendMethods.PolicyholderInPerson },
    { disabled: false, name: "ارسال با پیک", userCartableTitle: "منتظر ارسال دستگاه", centerCartableTitle: "منتظر دریافت دستگاه", value: enmSendMethods.Courier },
];

export interface IRepairCaseCenter extends IEntity {
    Substatus: enmRepairationStatus;
    RepairationSteps: { Substatus: enmRepairationStatus; CreateDateTime: any; }[];
    RepairCenterId?: number;
    CreateDateTime: any;
    RepairCenter?: ICenter;
    Creator?: IUser;
    RepairationStartTime?: Date | null;
    AdminConfirm: boolean;
    AdminDescription?: string;
}

export interface IRepairCase extends IEntity {
    Code: number;
    TicketNo: number;
    CustomerEquipmentModelId: number;
    CustomerEquipmentModel: ICustomerEquipmentModel;
    EmergencyCallNumber: string;
    Status: enmRepairCaseStatus;
    ProvinceId?: number;
    Province: IProvince;
    CityId?: number;
    City: ICity;
    Address?: string;
    Description?: string;
    SendMethod: enmSendMethods;
    RepairCaseCenters: IRepairCaseCenter[],
    RepairationStatus?: enmRepairationStatus;
    PayableAmount?: number;
    PayableAmountString: string;
    RepairCaseAttachments: IAttachment[];
    RepairCaseProblems: IRepairCaseProblem[];
    DeviceReceived?: boolean;
    DeviceReceivedDateTime?: Date;
    DeviceReturned?: boolean;
    DeviceReturnedDateTime?: Date;
    Paid?: boolean;
    PaymentDateTime?: Date;
    PaymentReceiptDateTime?: Date;
}

export interface IRepairCaseProblem extends IEntity {
    RepairCaseId: number;
    RepairCase: IRepairCase;
    EquipmentProblemId: number;
    EquipmentProblem: IEquipmentProblem;
}

export interface IRepairCaseProps extends IEntityManagerProps<IRepairCase> {

}

export interface IRepairCaseStates extends IEntityManagerStates<IRepairCase> {
    repairationSteps: any[];
}

export interface IRepairCaseInitialData extends IInitialData {
    Center?: ICenter;
}

export interface IRepairCaseFetchingInfo extends IFetchingInfo {
    RepairCenterId?: number;
    PolicyholderId?: number;
    RepairCenterFilter?: IFilter;
    ShowArchives?: boolean;
}
